import alt from '../alt';

class PositionActions {
    constructor() {
        this.generateActions('getSuccess');
    }
}

export default alt.createActions(PositionActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/PositionActions.js
 **/